/* dcsax-tool-yamaha-form.js
   Serial tool script, moved out of the Shopify page body 2026-09-28 so one copy serves every
   language. Translate & Adapt copies a page body, script included, into each language, which
   froze old scripts on /ja. Loaded by the dcsax_tool_css section in sections/header-group.json,
   only when the page body has no inline <script> of its own. Source: theme/staged-i18n-2026-09-28/yamaha-serial-page-paste.html
   Korean (ko) added 2026-09-29, staged in theme/staged-ko-2026-09-29/. Any language with a
   dictionary in DCSAX_I18N gets its own text; English is the fallback. */

(function () {
  // Same stamps as the serial lookup tool's Yamaha picker. Edit there first.
  var MODELS = {
    "Soprano": ["YSS-61", "YSS-62", "YSS-62R", "YSS-675", "YSS-875", "YSS-875EX", "YSS-82Z"],
    "Alto": ["YAS-61", "YAS-62", "YAS-855", "YAS-875", "YAS-875EX", "YAS-82Z"],
    "Tenor": ["YTS-61", "YTS-62", "YTS-875", "YTS-875EX", "YTS-82Z"],
    "Baritone": ["YBS-61", "YBS-62", "YBS-82"]
  };
  // DCSAX_I18N: per-locale strings, keyed on <html lang>, English fallback.
  // Same mechanism as the saxophone lookup. Model codes, brand names, serials,
  // emails and years stay as they are. Every localized branch is guarded by
  // DCSAX_LOC, so the English page renders exactly as before. Strings from a
  // data object are keyed by their path in that object.
  var DCSAX_LANG_FULL = String(document.documentElement.getAttribute("lang") || "en").toLowerCase();
  var DCSAX_LANG = DCSAX_LANG_FULL.split("-")[0];
  var DCSAX_I18N = {
    ja: {
      s: {
        "size.Soprano": "ソプラノ",
        "size.Alto": "アルト",
        "size.Tenor": "テナー",
        "size.Baritone": "バリトン",
        "pill.Date of manufacture, from Yamaha": "製造年月（ヤマハからの回答）",
        "pill.Date of purchase, bought new": "購入年月（新品で購入）",
        "pill.Receipt or warranty card": "領収書または保証書",
        "pill.I bought it and remember the year": "自分で購入し、年を覚えている",
        "pill.The original owner told me": "最初の所有者から聞いた",
        "date.none": "日付",
        "submit": "ヤマハのサックスを登録する",
        "date.manufacture": "製造年月",
        "date.purchase": "購入年月",
        "err.model": "ソプラノ、アルト、テナー、バリトンのいずれかを選び、次にモデルを選んでください。",
        "err.kind": "お持ちの日付の種類を選んでください。ヤマハから回答された製造年月か、購入年月のどちらかです。",
        "err.source": "購入年月をどのように確認したかを選んでください。",
        "sending": "送信中"
      }
    },
    ko: {
      s: {
        "size.Soprano": "소프라노",
        "size.Alto": "알토",
        "size.Tenor": "테너",
        "size.Baritone": "바리톤",
        "pill.Date of manufacture, from Yamaha": "제조 연월 (야마하의 답변)",
        "pill.Date of purchase, bought new": "구입 연월 (새 제품으로 구입)",
        "pill.Receipt or warranty card": "영수증 또는 보증서",
        "pill.I bought it and remember the year": "직접 구입했고 연도를 기억함",
        "pill.The original owner told me": "처음 소유자에게 들음",
        "date.none": "날짜",
        "submit": "야마하 색소폰 등록하기",
        "date.manufacture": "제조 연월",
        "date.purchase": "구입 연월",
        "err.model": "소프라노, 알토, 테너, 바리톤 중 하나를 선택한 다음 모델을 선택하십시오.",
        "err.kind": "가지고 계신 날짜의 종류를 선택하십시오. 야마하가 알려 준 제조 연월 또는 구입 연월입니다.",
        "err.source": "구입 연월을 어떻게 알게 되었는지 선택하십시오.",
        "sending": "전송 중"
      }
    },
    es: {
      "s": {
        "size.Soprano": "Soprano",
        "size.Alto": "Alto",
        "size.Tenor": "Tenor",
        "size.Baritone": "Barítono",
        "pill.Date of manufacture, from Yamaha": "Fecha de fabricación, dada por Yamaha",
        "pill.Date of purchase, bought new": "Fecha de compra, comprado nuevo",
        "pill.Receipt or warranty card": "Recibo o tarjeta de garantía",
        "pill.I bought it and remember the year": "Lo compré yo y recuerdo el año",
        "pill.The original owner told me": "Me lo dijo el primer dueño",
        "date.none": "Fecha",
        "submit": "Agregar mi Yamaha",
        "date.manufacture": "Fecha de fabricación",
        "date.purchase": "Fecha de compra",
        "err.model": "Elige soprano, alto, tenor o barítono y después el modelo.",
        "err.kind": "Indica qué fecha tienes: la fecha de fabricación que te dio Yamaha o la fecha de compra.",
        "err.source": "Indica cómo sabes la fecha de compra.",
        "sending": "Enviando"
      }
    },
    de: {
      "s": {
        "size.Soprano": "Sopran",
        "size.Alto": "Alt",
        "size.Tenor": "Tenor",
        "size.Baritone": "Bariton",
        "pill.Date of manufacture, from Yamaha": "Herstellungsdatum, von Yamaha genannt",
        "pill.Date of purchase, bought new": "Kaufdatum, neu gekauft",
        "pill.Receipt or warranty card": "Kaufbeleg oder Garantiekarte",
        "pill.I bought it and remember the year": "Ich habe es gekauft und weiß das Jahr noch",
        "pill.The original owner told me": "Der Erstbesitzer hat es mir gesagt",
        "date.none": "Datum",
        "submit": "Mein Yamaha eintragen",
        "date.manufacture": "Herstellungsdatum",
        "date.purchase": "Kaufdatum",
        "err.model": "Wählen Sie Sopran, Alt, Tenor oder Bariton und dann das Modell.",
        "err.kind": "Geben Sie an, welches Datum Sie haben: das Herstellungsdatum von Yamaha oder das Kaufdatum.",
        "err.source": "Geben Sie an, woher Sie das Kaufdatum kennen.",
        "sending": "Wird gesendet"
      }
    },
    it: {
      "s": {
        "size.Soprano": "Soprano",
        "size.Alto": "Contralto",
        "size.Tenor": "Tenore",
        "size.Baritone": "Baritono",
        "pill.Date of manufacture, from Yamaha": "Data di fabbricazione, fornita da Yamaha",
        "pill.Date of purchase, bought new": "Data di acquisto, comprato nuovo",
        "pill.Receipt or warranty card": "Ricevuta o certificato di garanzia",
        "pill.I bought it and remember the year": "L'ho comprato io e ricordo l'anno",
        "pill.The original owner told me": "Me l'ha detto il primo proprietario",
        "date.none": "Data",
        "submit": "Aggiungi il mio Yamaha",
        "date.manufacture": "Data di fabbricazione",
        "date.purchase": "Data di acquisto",
        "err.model": "Scegli soprano, contralto, tenore o baritono e poi il modello.",
        "err.kind": "Indica quale data hai: la data di fabbricazione fornita da Yamaha o la data di acquisto.",
        "err.source": "Indica come conosci la data di acquisto.",
        "sending": "Invio in corso"
      }
    },
    fr: {
      "s": {
        "size.Soprano": "Soprano",
        "size.Alto": "Alto",
        "size.Tenor": "Ténor",
        "size.Baritone": "Baryton",
        "pill.Date of manufacture, from Yamaha": "Date de fabrication, donnée par Yamaha",
        "pill.Date of purchase, bought new": "Date d'achat, acheté neuf",
        "pill.Receipt or warranty card": "Reçu ou carte de garantie",
        "pill.I bought it and remember the year": "Je l'ai acheté et je me souviens de l'année",
        "pill.The original owner told me": "Le premier propriétaire me l'a dit",
        "date.none": "Date",
        "submit": "Ajouter mon Yamaha",
        "date.manufacture": "Date de fabrication",
        "date.purchase": "Date d'achat",
        "err.model": "Choisissez soprano, alto, ténor ou baryton, puis le modèle.",
        "err.kind": "Indiquez quelle date vous avez : la date de fabrication donnée par Yamaha ou la date d'achat.",
        "err.source": "Indiquez comment vous connaissez la date d'achat.",
        "sending": "Envoi en cours"
      }
    },
    // DCSAX_ZH_START (built by tools/locale-zh/build.py from theme/staged-i18n-zh-2026-10-18)
    "zh-tw": {
      "s": {
        "size.Soprano": "高音",
        "size.Alto": "中音",
        "size.Tenor": "次中音",
        "size.Baritone": "上低音",
        "pill.Date of manufacture, from Yamaha": "製造年月（Yamaha 的回覆）",
        "pill.Date of purchase, bought new": "購買年月（購買時為全新）",
        "pill.Receipt or warranty card": "收據或保固卡",
        "pill.I bought it and remember the year": "我自己購買，記得年份",
        "pill.The original owner told me": "第一任擁有者告訴我的",
        "date.none": "日期",
        "submit": "登錄您的 Yamaha 薩克斯風",
        "date.manufacture": "製造年月",
        "date.purchase": "購買年月",
        "err.model": "請先選擇高音、中音、次中音或上低音，再選擇型號。",
        "err.kind": "請選擇您持有的日期種類：Yamaha 回覆的製造年月，或購買年月。",
        "err.source": "請選擇您如何確認購買年月。",
        "sending": "傳送中"
      }
    },
    "zh-cn": {
      "s": {
        "size.Soprano": "高音",
        "size.Alto": "中音",
        "size.Tenor": "次中音",
        "size.Baritone": "上低音",
        "pill.Date of manufacture, from Yamaha": "制造年月（Yamaha 的回复）",
        "pill.Date of purchase, bought new": "购买年月（购买时为全新）",
        "pill.Receipt or warranty card": "收据或保固卡",
        "pill.I bought it and remember the year": "我自己购买，记得年份",
        "pill.The original owner told me": "第一任拥有者告诉我的",
        "date.none": "日期",
        "submit": "登录您的 Yamaha 萨克斯",
        "date.manufacture": "制造年月",
        "date.purchase": "购买年月",
        "err.model": "请先选择高音、中音、次中音或上低音，再选择型号。",
        "err.kind": "请选择您持有的日期种类：Yamaha 回复的制造年月，或购买年月。",
        "err.source": "请选择您如何确认购买年月。",
        "sending": "发送中"
      }
    }
    // DCSAX_ZH_END
  };
  var DCSAX_L = DCSAX_I18N[DCSAX_LANG_FULL] || DCSAX_I18N[DCSAX_LANG] || null;
  // True for every language with a dictionary (ja, ko).
  var DCSAX_LOC = !!DCSAX_L;
  function dcsaxT(key, en) { return (DCSAX_L && DCSAX_L.s && typeof DCSAX_L.s[key] === "string") ? DCSAX_L.s[key] : en; }
  function dcsaxF(key, args) { return String(dcsaxT(key, "")).replace(/\{(\d+)\}/g, function (m, i) { return args[+i] === undefined ? "" : String(args[+i]); }); }
  var form = document.getElementById("dcy-form");
  if (!form) return;
  var sizes = document.getElementById("dcy-sizes");
  var models = document.getElementById("dcy-models");
  var model = document.getElementById("dcy-model");
  var kind = document.getElementById("dcy-kind");
  var source = document.getElementById("dcy-source");
  var size = "";

  function pill(text, selected, onPick) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "pill" + (selected ? " selected" : ""); b.textContent = text;
    b.addEventListener("click", onPick);
    return b;
  }
  function renderModels() {
    sizes.innerHTML = ""; models.innerHTML = "";
    Object.keys(MODELS).forEach(function (s) {
      sizes.appendChild(pill(DCSAX_LOC ? dcsaxT("size." + s, "") : s, s === size, function () { size = s; model.value = ""; renderModels(); }));
    });
    (MODELS[size] || []).forEach(function (m) {
      models.appendChild(pill(m, m === model.value, function () { model.value = m; renderModels(); }));
    });
  }
  // A row of pills where one is picked and its text lands in a hidden field.
  function single(rowId, field, after) {
    var row = document.getElementById(rowId);
    Array.prototype.forEach.call(row.querySelectorAll(".pill"), function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call(row.querySelectorAll(".pill"), function (o) { o.className = "pill"; });
        b.className = "pill selected";
        field.value = b.getAttribute("data-v");
        if (after) after();
      });
    });
  }
  single("dcy-kinds", kind, function () {
    var bought = /purchase/.test(kind.value);
    document.getElementById("dcy-g-source").style.display = bought ? "" : "none";
    document.getElementById("dcy-date-lbl").textContent = DCSAX_LOC ? dcsaxT(bought ? "date.purchase" : "date.manufacture", "") : bought ? "Date of purchase" : "Date of manufacture";
    if (!bought) {
      source.value = "";
      Array.prototype.forEach.call(document.querySelectorAll("#dcy-sources .pill"), function (o) { o.className = "pill"; });
    }
  });
  single("dcy-sources", source);
  // Localized: the date label and the submit button are rewritten by this
  // script later, so they get their localized text here as well.
  if (DCSAX_LOC) { document.getElementById("dcy-date-lbl").textContent = dcsaxT("date.none", ""); document.getElementById("dcy-submit").textContent = dcsaxT("submit", ""); }
  // Localized pill labels. The submitted value is data-v, which stays English.
  if (DCSAX_LOC) Array.prototype.forEach.call(document.querySelectorAll("#dcy-kinds .pill, #dcy-sources .pill"), function (b) {
    b.textContent = dcsaxT("pill." + b.getAttribute("data-v"), b.textContent);
  });
  renderModels();

  var q = new URLSearchParams(location.search);
  if (q.get("posted") === "1" || q.get("contact_posted") === "true") {
    document.getElementById("dcy-thanks").style.display = "";
  }

  function fail(e, message, target) {
    e.preventDefault();
    var err = document.getElementById("dcy-err");
    err.textContent = message; err.style.display = "";
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  form.addEventListener("submit", function (e) {
    if (!model.value) return fail(e, DCSAX_LOC ? dcsaxT("err.model", "") : "Pick soprano, alto, tenor or baritone, then the model.", document.getElementById("dcy-g-model"));
    if (!kind.value) return fail(e, DCSAX_LOC ? dcsaxT("err.kind", "") : "Say which date you have: manufacture from Yamaha, or purchase.", document.getElementById("dcy-g-kind"));
    if (/purchase/.test(kind.value) && !source.value) return fail(e, DCSAX_LOC ? dcsaxT("err.source", "") : "Say how you know the purchase date.", document.getElementById("dcy-g-source"));
    document.getElementById("dcy-err").style.display = "none";
    var btn = document.getElementById("dcy-submit");
    btn.textContent = DCSAX_LOC ? dcsaxT("sending", "") : btn.getAttribute("data-sending"); btn.disabled = true;
  });
})();
